












import { Component, Prop, Vue } from "vue-property-decorator";

import { ResourceHelper } from "@/helper/resourceHelper"
import { FontManager } from '@/model/fontManager/fontManager';
import { DebugHelper } from "@/helper/debugHelper";

import * as def from "@/definitions";
@Component({
  components: {}
})
export default class DropdownList extends Vue {
    // タグ
    @Prop() tag!: string;

    // リストアイテム
    @Prop() private items!: Array<{
        id: number;
        label: string;
        isSelected: boolean;
    }>;

    private close() {
        this.$emit("close");
    }

    private onClick(id) {
        this.$emit("close");
        this.$emit("select", id, this.tag);
    }

    get selected(){
        return {
            'background-color' : this.$store.getters.userConfigColors.buttonColorCode,
            'color' : '#ffffff'
        }
    }

    get unSelected(){
        return {
            'color' : this.$store.getters.userConfigColors.textAColor
        }
    }
}
